import { render, staticRenderFns } from "./CardEmpresasCadastradas.vue?vue&type=template&id=4ff7c669&"
import script from "./CardEmpresasCadastradas.vue?vue&type=script&lang=js&"
export * from "./CardEmpresasCadastradas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports